function validateForm() {
    (function () {
        'use strict'

        var forms = document.querySelectorAll('.needs-validation');
        let confirm = document.querySelector('#password_popup_confirm');
        Array.prototype.slice.call(forms)
            .forEach(function (form) {
                form.addEventListener('submit', function (event) {
                    let passwordField = form.querySelector('#password_popup');

                    if(passwordField) {
                        if (passwordField.value !== confirm.value) {
                            confirm.setCustomValidity("La contraseña no coincide");
                            confirm.classList.add('is-invalid');
                            event.preventDefault();
                        }
                    }

                    if (!form.checkValidity()) {
                        event.preventDefault()
                        event.stopPropagation()
                    } else {
                        let loader = form.querySelector('.loader_form');
                        loader.classList.add("show_loader");
                    }
                    form.classList.add('was-validated')
                }, false)
            })

        let numbers = document.querySelectorAll('.number_only');

        Array.prototype.slice.call(numbers)
            .forEach(function (number) {
                number.addEventListener('keypress', function (event) {
                    let keycode = event.which;
                    if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
                        event.preventDefault();
                    }
                });
            });
    })()
}

export { validateForm }